module.exports = __webpack_public_path__ + "img/character-dog-happy.d5745a40.svg";